import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  dashboardItemSoldThunk,
  dashEarningThunk,
  dashNewOrderThunk,
  dashTotalProductsThunk,
  GetOrderStatistics,
} from "../../../../store/thunks/dashboardThunk";
import { Tooltip } from "antd";

export const DashboardCardData = ({
  slug,
  cardTitle,
  cardImg,
  bgClass = "",
  cardTitleClass = "",
  cardNumberClass = "",
  bgStyle = {},
  tooltipTitle = "",
}) => {
  const dispatch = useDispatch();

  const { grossEarnings, totalProducts,} =
    useSelector((state) => {
      return {
        itemSold: state?.dashboardItemSold,
        newOrder: state?.dashNewOrder,
        grossEarnings: state?.dashEarning,
        totalProducts: state?.dashTotalProduct,
        loading: state?.loading,
        error: state?.error,
      };
    });

  const { data: orderStats } = useSelector(
    (state) => state?.orderStatistics || {},
  );

  useEffect(() => {
    if (slug === "delivered_items" && !orderStats?.["DELIVERED"]) {
      dispatch(GetOrderStatistics({ orderStage: "DELIVERED" }));
    } else if (slug === "new_orders" && !orderStats?.[null]) {
      dispatch(GetOrderStatistics({ orderStage: null }));
    } else if (slug === "cancelled_items" && !orderStats?.["CANCELLED"]) {
      dispatch(GetOrderStatistics({ orderStage: "CANCELLED" }));
    } else if (slug === "returned_items" && !orderStats?.["RETURN"]) {
      dispatch(GetOrderStatistics({ orderStage: "RETURN" }));
    } else if (slug === "total_products" && !totalProducts?.data) {
      dispatch(dashTotalProductsThunk());
    } else if (slug === "gross_earnings" && !grossEarnings?.data) {
      dispatch(dashEarningThunk());
    }
  }, [dispatch, slug]);

  const data =
    slug === "delivered_items"
      ? orderStats?.["DELIVERED"]
      : slug === "new_orders"
        ? orderStats?.[null]
        : slug === "cancelled_items"
          ? orderStats?.["CANCELLED"]
          : slug === "returned_items"
            ? orderStats?.["RETURN"]
            : slug === "gross_earnings"
              ? Number(grossEarnings?.data ?? 0).toFixed(2)
              : slug === "total_products"
                ? totalProducts?.data
                : "-";
  console.log("data", data);
  return (
    <Tooltip title={tooltipTitle}>
      <div
        className={`card card-custom card-stretch ${bgClass}`}
        style={bgStyle}
      >
        <div className="card-body p-3">
          <div className="d-flex flex-wrap align-items-center">
            <div className="d-flex flex-column flex-grow-1 mb-3 pr-3">
              <p
                className={`font-weight-bolder font-size-h4 m-0 ${cardTitleClass}`}
              >
                {cardTitle}
              </p>
              <p
                className={`font-weight-bolder font-size-h4 m-0 mt-1 ${cardNumberClass}`}
              >
                {data ?? "-"}
              </p>
            </div>
            <div className="symbol symbol-60 symbol-light ml-5 ml-auto">
              <span className="symbol-label">
                <img
                  src={cardImg}
                  className="align-self-center rounded"
                  alt=""
                />
              </span>
            </div>
            <div className="d-flex flex-column w-100 mt-1">
              <span className="text-dark-75 m-0 font-size-sm font-weight-bold pb-0">
                &nbsp;
              </span>
            </div>
          </div>
        </div>
      </div>
    </Tooltip>
  );
};
